// extracted by mini-css-extract-plugin
export default {"colors":"'../../../styles/colors.module.css'","gray-500":"#979797","gray500":"#979797","purpley":"#8342f7","root":"uploadbox_root__qXeMo","icon":"uploadbox_icon__7RUd1"};